import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import AppProvider from 'providers/AppProvider'; /* Note VG: s'appelait MAIN dans les versions précédentes */
import { router } from 'routes';
import 'helpers/initFA';

import moment from 'moment-timezone';
import 'moment/locale/fr';
moment.updateLocale('fr', {
  weekdays : 'Dimanche_Lundi_Mardi_Mercredi_Jeudi_Vendredi_Samedi'.split('_'),
  weekdaysShort: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
  weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
  months : 'Janvier_Février_Mars_Avril_Mai_Juin_Juillet_Août_Septembre_Octobre_Novembre_Décembre'.split('_'),
  monthsShort : 'Jan_Fév_Mar_Avr_Mai_Juin_Juil_Août_Sept_Oct_Nov_Déc'.split('_'),
  monthsMin : 'Jan_Fév_Mar_Avr_Mai_Juin_Juil_Août_Sept_Oct_Nov_Déc'.split('_'),
});

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import  { BreakpointProvider } from 'react-socks';

const container = document.getElementById('main');
const root = createRoot(container);

root.render(
  <>
    <ToastContainer
      theme="light"
      position="top-center"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={true}
      rtl={false}
      pauseOnFocusLoss={false}
      draggable
      draggablePercent={60}
      pauseOnHover
      limit={5}
    />
    <AppProvider>
      <BreakpointProvider>
        <RouterProvider router={router} />
      </BreakpointProvider>
    </AppProvider>
  </>
);
